import {Button} from 'antd'
import {useReadOnly} from '@/components/Form/ReadOnly.mjs'
import {Confirm, useOpenModal} from '@/components/Modal'
import {chooseFiles, getExt} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import http from '@/biz/http.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'

const PropertiesPaneButtonUpload = (props) => {
    const openModal = useOpenModal()
    const readOnly = useReadOnly()
    const [values, update] = useProperties()
    const map = useMapContext()
    const {prjId} = map.data

    if (readOnly) {
        return null
    }

    const handleClick = async () => {
        const [file] = await chooseFiles()

        if (! file) {
            return
        }

        const {fileId} = await runAsync(
            () => http.upload({file, pathName: prjId}),
            {action: '上传文件'}
        )

        const bizNodeType = /^image\//.test(file.type) ? 'PIC' : 'DOC'
        const {name, type} = file
        const ext = getExt(name)

        const text = await (async () => {
            if (values.text === map.BizNode.DOC.typeName(map)) {
                return name
            }

            const confirmed = await openModal(
                <Confirm>是否按文件名更新节点标题</Confirm>
            )

            if (confirmed) {
                return name
            }
            else {
                return values.text.replace(/\.[^.]*$/, `.${ext}`)
            }
        })()

        update({bizNodeType, ext, fileId, text, type})
    }

    return (
        <Button
            {...props}
            onClick={handleClick}
        >上传</Button>
    )
}

export default PropertiesPaneButtonUpload
